export default __webpack_public_path__ + "static/media/bearer-logo-aust.fbe9574c.svg";